export default "__VITE_ASSET__D8LMQ2f0__"